"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
class OrganizationTag {
    constructor({ buckets }) {
        this.buckets = buckets;
    }
}
OrganizationTag.fromJSON = (json) => {
    const { buckets } = Object.assign({}, json);
    try {
        if (!Array.isArray(buckets)) {
            throw new Error('buckets should be array');
        }
        const _buckets = buckets.map(bucket => Bucket_1.default.fromJSON(bucket));
        return new OrganizationTag({
            buckets: _buckets,
        });
    }
    catch (_a) {
        throw new Error('.facets.OrganizationTag must be a { buckets: { value: string; count: number }[]}');
    }
};
exports.default = OrganizationTag;
